<!-- New create/edit button -->

<div [ngClass]="{ 'has-edit-button': isEditMode }">
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-Article-document"
    folderTemplateQuery="new-Article-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>
  <!--article class used for custom print only-->
  <!-- Render Content -->
  <div
    *ngIf="document && content && !segmentOk"
    edsSpacing="lg"
    class="article"
  >
    <!-- article banner  area -->
    <eds-banner-article-insights
      edsSpacing="xl"
      [breadcrumbItems]="breadcrumbItems"
      [theme]="this.pageTheme"
      [preTitle]="
        content.hideDate
          ? content.archiveLabel
          : content.isodate + content.archiveLabel
      "
      [title]="content.title"
      [readTime]="
        content.readingTime > 0
          ? content.readingTime + ' ' + translationLabel?.minuteRead
          : ''
      "
      [subTitle]="content.cardSummary"
      [buttonType]="buttontype"
      [btnAudio]="translationLabel?.audio"
      [audioLink]="content.audioHref"
      [btnSummaryPdf]="content.pdf?.length ? content.pdf[0]?.displayText : ''"
      [pdfSummaryLink]="content.pdf?.length ? content.pdf[0]?.href : ''"
      [isSummaryNewWindow]="
        content.pdf?.length ? content.pdf[0]?.isNewWindow : ''
      "
      [summaryExternalLink]="
        content.pdf?.length ? content.pdf[0]?.external : ''
      "
      [btnCompletePdf]="content.pdf?.length ? content.pdf[1]?.displayText : ''"
      [pdfCompleteLink]="content.pdf?.length ? content.pdf[1]?.href : ''"
      [isCompleteNewWindow]="
        content.pdf?.length ? content.pdf[1]?.isNewWindow : ''
      "
      [completeExternalLink]="
        content.pdf?.length ? content.pdf[1]?.external : ''
      "
      [imageSrc]="
        content.cardImageOnly || content.imgSrc === 'javascript:void(0)'
          ? ''
          : content.imgSrc
      "
      [collectionLabel]="content.eyebrow?.collections"
      [topicLabel]="content.eyebrow?.topic"
      [ftTrademark]="content.eyebrow?.trademark"
      [hasMediaTag]="content.mediaTag"
      [isMediaTagPodcast]="content.mediaTag?.type === 'Podcast'"
      [isMediaTagVideo]="content.mediaTag?.type === 'Video'"
      [mediaTagLabel]="content.mediaTag?.label"
      [widenParams]="widenMetaData"
      [targetedButtons]="targetedButtons"
      [isLoggedIn]="isLoggedIn"
    ></eds-banner-article-insights>
    <!-- /article banner  area -->

    <!-- article content area -->

    <section edsGrid edsSpacing="xl">
      <div class="container container--wide">
        <div edsSubGrid="layout-3" edsSubGridGap="xxxl">
          <div class="articles-promo__glance-content">
            <div edsRow>
              <ft-insights-tags
                edsCol
                [insightsTags]="content"
              ></ft-insights-tags>
            </div>

            <ng-container *ngIf="isHandheld && showArticleInfo">
              <div edsPadding edsPaddingAll="sm">
                <ng-container
                  edsSpacing="md"
                  *ngTemplateOutlet="
                    articleInforTemplete;
                    context: { content: content }
                  "
                ></ng-container>
              </div>
            </ng-container>

            <div edsSpacing="md">
              <ng-container
                *ngFor="let content of content.contentBlocks"
                [ngSwitch]="content.type"
              >
                <ng-template ngSwitchCase="TitleBlock">
                  <div [edsSpacing]="content.spacingBottom">
                    <ft-title-block
                      [content]="content"
                      [isTwoCol]="true"
                    ></ft-title-block>
                  </div>
                </ng-template>
                <ng-template ngSwitchCase="IntroBlock">
                  <div [edsSpacing]="content.spacingBottom">
                    <ft-text-block
                      [content]="content"
                      [isTwoCol]="true"
                    ></ft-text-block>
                  </div>
                </ng-template>
                <ng-template ngSwitchCase="ParagraphBlock">
                  <div [edsSpacing]="content.spacingBottom">
                    <ft-text-block
                      [content]="content"
                      [isTwoCol]="true"
                    ></ft-text-block>
                  </div>
                </ng-template>
                <ng-template ngSwitchCase="Avatar">
                  <div edsRow [edsSpacing]="content.spacingBottom">
                    <div edsCol>
                      <ft-avatar-block
                        [isTwoCol]="true"
                        [content]="content"
                        [page]="page"
                        [navigateToAvatar]="false"
                        [isRenderedAsArticle]="true"
                      ></ft-avatar-block>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngSwitchCase="Blockquote">
                  <div [edsSpacing]="content.spacingBottom">
                    <ft-blockquote-block
                      [content]="content"
                      [isTwoCol]="true"
                    ></ft-blockquote-block>
                  </div>
                </ng-template>
                <ng-template ngSwitchCase="EmbeddedVideo">
                  <div edsRow [edsSpacing]="content.spacingBottom">
                    <div edsCol>
                      <eds-video [embedScript]="content.videoEmbedCode">
                      </eds-video>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngSwitchCase="HighlightBlock">
                  <div edsRow [edsSpacing]="content.spacingBottom">
                    <div edsCol>
                      <eds-highlight-block
                        [title]="content.title"
                        [bodyContent]="content.content | safeHtml"
                      ></eds-highlight-block>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngSwitchCase="MarketoForm">
                  <div edsRow [edsSpacing]="content.spacingBottom">
                    <div edsCol>
                      <ft-marketo-form
                        [externalId]="content.id"
                        [externalSuccessTitle]="content.successMsg"
                        [externalSuccessMessage]="content.successMsg"
                        [externalMarginBottom]="'auto'"
                      ></ft-marketo-form>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngSwitchDefault>
                  <div *ngIf="content.cardCompound; else elseBlock">
                    <div edsRow>
                      <div edsCol>
                        <div edsGrid>
                          <div
                            [edsSubGrid]="
                              content?.cardCompound?.length > 1
                                ? 'layout-1'
                                : ' layout-0'
                            "
                            *ngIf="
                              content.style === 'Promo Card' &&
                              content.isAllowed
                            "
                            [edsSpacing]="content.spacingBottom"
                          >
                            <eds-promo-card
                              *ngFor="
                                let card of content?.cardCompound;
                                let i = index
                              "
                              [title]="card.title"
                              [subTitle]="card.content"
                              [promoImageSrc]="card.imageSrc"
                              [linkBtnHref]="card?.href"
                              [isNewWindow]="card?.isNewWindow === '_blank'"
                              [theme]="i === 0 ? 'primary' : 'secondary'"
                              [hasThumbnail]="true"
                              [externalLink]="card?.externalLink"
                            ></eds-promo-card>
                          </div>
                          <div
                            [edsSubGrid]="'layout-0'"
                            *ngIf="
                              content.style === 'Media Card' &&
                              content.isAllowed
                            "
                            [edsSpacing]="content.spacingBottom"
                          >
                            <eds-media-card
                              *ngFor="
                                let card of content?.cardCompound;
                                let i = index
                              "
                              [title]="card.title"
                              [bodyContent]="card.content"
                              [isIcon]="card.isIcon"
                              [imgSrc]="card.imageSrc"
                              [linkText]="card?.ctaText"
                              [url]="card?.href"
                              [externalLink]="card?.externalLink"
                              [isNewWindow]="card?.isNewWindow"
                              [wrap]="true"
                            >
                            </eds-media-card>
                          </div>
                          <div
                            [edsSubGrid]="'layout-0'"
                            *ngIf="
                              content.style === 'Feature Card' &&
                              content.isAllowed
                            "
                            [edsSpacing]="content.spacingBottom"
                          >
                            <eds-card-featured
                              *ngIf="content.isAllowed"
                              [doubleContent]="false"
                              [imageFeatured]="true"
                              [cards]="content.cardCompound"
                              [singleCard]="isSingleCard"
                            ></eds-card-featured>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #elseBlock>
                    <div
                      class="article__spacing-bottom"
                      edsRow
                      [edsSpacing]="content.spacingBottom"
                    >
                      <div edsCol>
                        <ft-image-block [content]="content"></ft-image-block>
                      </div>
                    </div>
                  </ng-template>
                </ng-template>
              </ng-container>
            </div>
            <div *ngIf="content.legal">
              <div edsRow>
                <eds-divider edsCol edsSpacing="lg"></eds-divider>
              </div>
              <div edsRow>
                <eds-legal *ngIf="content.legal" edsCol [hasSection]="true">
                  <div section [innerHTML]="content.legal | safeHtml"></div>
                </eds-legal>
              </div>
            </div>
            <!-- social share -->
            <div
              edsRow
              edsSpacing="lg"
              *ngIf="
                !siteParams.isSocialMediaSharingButtonsDisabled &&
                content.socialMedia
              "
            >
              <div edsCol>
                <ft-social-share [pageType]="pageType"></ft-social-share>
              </div>
            </div>
            <!-- /social share -->
          </div>
          <!-- article sidebar -->
          <div class="subscribe">
            <ng-container
              *ngFor="let content of content.rightRail"
              [ngSwitch]="content.type"
            >
              <ng-template ngSwitchCase="TitleBlock">
                <div [edsSpacing]="content.spacingBottom">
                  <ft-title-block
                    [content]="content"
                    [isTwoCol]="true"
                  ></ft-title-block>
                </div>
              </ng-template>
              <ng-template ngSwitchCase="IntroBlock">
                <div [edsSpacing]="content.spacingBottom">
                  <ft-text-block
                    [content]="content"
                    [isTwoCol]="true"
                  ></ft-text-block>
                </div>
              </ng-template>
              <ng-template
                ngSwitchCase="ParagraphBlock"
                *ngIf="content?.isAllowed"
              >
                <div [edsSpacing]="content.spacingBottom">
                  <ft-text-block
                    [content]="content"
                    [isTwoCol]="true"
                  ></ft-text-block>
                </div>
              </ng-template>
              <ng-template ngSwitchCase="Avatar">
                <div edsRow [edsSpacing]="content.spacingBottom">
                  <div edsCol>
                    <ft-avatar-block
                      [isTwoCol]="true"
                      [content]="content"
                      [page]="page"
                      [navigateToAvatar]="false"
                      [isRenderedAsArticle]="true"
                    ></ft-avatar-block>
                  </div>
                </div>
              </ng-template>
              <ng-template ngSwitchCase="Blockquote">
                <div [edsSpacing]="content.spacingBottom">
                  <ft-blockquote-block
                    [content]="content"
                    [isTwoCol]="true"
                  ></ft-blockquote-block>
                </div>
              </ng-template>
              <ng-template ngSwitchCase="EmbeddedVideo">
                <div edsRow [edsSpacing]="content.spacingBottom">
                  <div edsCol>
                    <eds-video [embedScript]="content.videoEmbedCode">
                    </eds-video>
                  </div>
                </div>
              </ng-template>
              <ng-template ngSwitchCase="HighlightBlock">
                <div edsRow [edsSpacing]="content.spacingBottom">
                  <div edsCol>
                    <eds-highlight-block
                      [title]="content.title"
                      [bodyContent]="content.content | safeHtml"
                    ></eds-highlight-block>
                  </div>
                </div>
              </ng-template>
              <ng-template ngSwitchCase="MarketoForm">
                <div edsRow [edsSpacing]="content.spacingBottom">
                  <div edsCol>
                    <ft-marketo-form
                      [externalId]="content.id"
                      [externalSuccessTitle]="content.successMsg"
                      [externalSuccessMessage]="content.successMsg"
                      [externalMarginBottom]="'auto'"
                    ></ft-marketo-form>
                  </div>
                </div>
              </ng-template>
              <ng-template ngSwitchDefault>
                <div *ngIf="content.cardCompound; else elseBlock">
                  <div edsRow>
                    <div edsCol>
                      <div
                        *ngIf="content.style === 'Feature Card'"
                        [edsSpacing]="content.spacingBottom"
                      >
                        <eds-card-featured
                          [doubleContent]="false"
                          [imageFeatured]="true"
                          [cards]="content.cardCompound"
                          [singleCard]="isSingleCard"
                          edsSpacing="xl"
                        ></eds-card-featured>
                      </div>
                      <div
                        *ngIf="content.style === 'Media Card'"
                        [edsSpacing]="content.spacingBottom"
                      >
                        <eds-media-card
                          *ngFor="
                            let card of content?.cardCompound;
                            let i = index
                          "
                          [title]="card.title"
                          [bodyContent]="card.content"
                          [isIcon]="card.isIcon"
                          [imgSrc]="card.imageSrc"
                          [linkText]="card?.ctaText"
                          [url]="card?.href"
                          [externalLink]="card?.externalLink"
                          [isNewWindow]="card?.isNewWindow"
                          [wrap]="true"
                        >
                        </eds-media-card>
                      </div>
                      <div
                        *ngIf="
                          content.style === 'Promo Card' && content.isAllowed
                        "
                        [edsSpacing]="content.spacingBottom"
                      >
                        <eds-promo-card
                          *ngFor="
                            let card of content?.cardCompound;
                            let i = index
                          "
                          [title]="card?.title"
                          [subTitle]="card?.content"
                          [promoImageSrc]="card?.imageSrc"
                          [theme]="i === 0 ? 'primary' : 'secondary'"
                          [linkBtnHref]="card?.href"
                          [isNewWindow]="card?.isNewWindow === '_blank'"
                          [externalLink]="card?.externalLink"
                        ></eds-promo-card>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #elseBlock>
                  <div
                    edsRow
                    class="article__spacing-bottom"
                    [edsSpacing]="content.spacingBottom"
                  >
                    <div edsCol>
                      <ft-image-block [content]="content"></ft-image-block>
                    </div>
                  </div>
                </ng-template>
              </ng-template>
            </ng-container>

            <eds-panel
              *ngIf="!isHandheld && showArticleInfo"
              [hasShadows]="true"
              edsSpacing="xl"
              [hasPadding]="true"
            >
              <ng-container
                edsSpacing="md"
                *ngTemplateOutlet="
                  articleInforTemplete;
                  context: { content: content }
                "
              ></ng-container>
            </eds-panel>
            <div
              #sidebar
              edsPadding
              [edsPaddingLeft]="isMobile ? 'sm' : 'none'"
            >
              <div class="text-grey1">
                <div
                  edsPadding
                  edsPaddingBottom="xl"
                  *ngIf="jumplinkDet?.jumplinks?.length"
                >
                  <eds-sidebar
                    [label]="translationLabel?.jumpToLinkHeader"
                    [hasShadows]="false"
                    [hasBorders]="false"
                    [hasPadding]="false"
                    [divider]="false"
                  >
                    <eds-list-jumplink
                      [jumplinks]="jumplinkDet.jumplinks"
                      [compact]="compactdet"
                    ></eds-list-jumplink>
                  </eds-sidebar>
                </div>
                <!-- subscribe -->
                <ng-container *ngIf="content.subscribe">
                  <p class="bold" edsSpacing="md">
                    {{ translationLabel?.subscribe | uppercase }}
                  </p>
                  <button
                    [hasIcon]="true"
                    edsButton="primary"
                    size="compact"
                    edsSpacing="md"
                  >
                    <span edsPadding edsPaddingRight="md">
                      {{ translationLabel?.subscribeNow }}
                    </span>
                    <eds-icon type="mail" size="small"></eds-icon>
                  </button>
                </ng-container>
                <!-- /subscribe -->

                <!-- related content -->

                <ng-container
                  *ngIf="content.relatedContent?.length && showRelatedArticle"
                >
                  <div
                    edsSpacing="xl"
                    *ngFor="let relatedContent of content.relatedContent"
                  >
                    <ng-container
                      *ngIf="relatedContent?.localizableLink?.length"
                    >
                      <eds-sidebar
                        [label]="
                          relatedContent.showHeading
                            ? relatedContentHeaderTypeLabel[
                                relatedContent.heading
                              ]
                            : ('' | uppercase)
                        "
                        [hasShadows]="
                          relatedContent.heading === 'related-content'
                        "
                        [hasBorders]="
                          relatedContent.heading === 'related-content'
                        "
                        [hasPadding]="
                          relatedContent.heading === 'related-content'
                        "
                        [hasRelatedArticles]="
                          relatedContent.heading === 'related-content'
                        "
                      >
                        <div
                          *ngFor="
                            let localizeLink of relatedContent.localizableLink;
                            let i = index
                          "
                        >
                          <ng-container *ngIf="localizeLink.isAllowed">
                            <eds-article-sidebar-item
                              [date]="localizeLink.dateString"
                              [title]="
                                localizeLink.link.displayText | decodeHtml
                              "
                              [href]="localizeLink.link.url"
                              [target]="localizeLink.link.target"
                              [isExternalLink]="localizeLink.link.external"
                              [signInRequired]="
                                localizeLink.link.signInLink
                                  | ftIsSignInRequired
                                  | async
                              "
                              [hideLockIcon]="true"
                              [hasRelatedArticles]="
                                relatedContent.heading === 'related-content'
                              "
                            ></eds-article-sidebar-item>
                          </ng-container>
                          <ng-container
                            *ngIf="
                              i < relatedContent.localizableLink.length - 1
                            "
                          >
                            <eds-divider
                              *ngIf="localizeLink.isAllowed"
                              edsPadding
                              edsPaddingBottom="sm"
                            ></eds-divider>
                          </ng-container>
                        </div>
                      </eds-sidebar>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-container
                  *ngIf="isDynamicRelatedArticle && relateArticleData?.length"
                >
                  <div edsSpacing="xl">
                    <eds-card-article
                      *ngFor="let article of relateArticleData"
                      [title]="article?._source?.title"
                      [date]="article?._source?.referenceDate_formatted"
                      [href]="article?._source?.url"
                      [isCompact]="true"
                      [description]="article?._source?.description"
                    >
                    </eds-card-article>
                  </div>
                </ng-container>

                <!-- /related content -->
              </div>
            </div>
            <div #stickySidebar>
              <eds-article-side-bar
                [relatedArticleslabel]="
                  content.relatedContent &&
                  content.relatedContent[0]?.showHeading
                    ? relatedContentHeaderTypeLabel[
                        content.relatedContent[0]?.heading
                      ]
                    : ''
                "
                [subscribeFormlabel]="translationLabel?.subscribe"
                [articles]="
                  content.relatedContent?.length
                    ? content.relatedContent[0]
                    : ''
                "
                [showButtons]="showButtons"
                [mobileText]="translationLabel?.moreContent"
                [showSubscribeForm]="content.subscribe == true ? true : false"
                [showArticle]="showArticle"
              >
                <div
                  subscribe
                  class="text-dark-grey article-side-bar__subscribeForm"
                >
                  <p edsSpacing="sm">
                    {{ translationLabel?.subscribeUptoDate }}
                  </p>

                  <div edsSpacing="xs">
                    <eds-text-input
                      [placeholder]="translationLabel?.enterText"
                      [label]="translationLabel?.fullname"
                      type="fullnameType"
                      required="true"
                      aria-label=""
                    ></eds-text-input>
                  </div>
                  <div edsSpacing="xs">
                    <eds-text-input
                      [placeholder]="translationLabel?.enterText"
                      [label]="translationLabel?.email"
                      type="emailType"
                      required="true"
                      aria-label=""
                    ></eds-text-input>
                  </div>
                  <!--<p edsSpacing="sm" class="sidebar__small-font">-->
                  <!--This is a helper text message-->
                  <!--</p>-->
                  <div edsFlexbox justifyContent="flex-end">
                    <button
                      class="ft__btn--no-margin"
                      edsSpacing="xs"
                      href="#"
                      edsButton="primary"
                    >
                      {{ translationLabel?.subscribe }}
                    </button>
                  </div>
                </div>
                <div article class="article-side-bar__articles">
                  <ng-container *ngIf="content.relatedContent?.length">
                    <ng-container
                      *ngIf="content.relatedContent[0]?.localizableLink?.length"
                    >
                      <div
                        *ngFor="
                          let localizeLink of content.relatedContent[0]
                            ?.localizableLink;
                          let i = index
                        "
                      >
                        <ng-container *ngIf="localizeLink.isAllowed">
                          <eds-article-sidebar-item
                            [date]="localizeLink.dateString"
                            [title]="localizeLink.link.displayText"
                            [href]="localizeLink.link.url"
                            [target]="localizeLink.link.target"
                            [isExternalLink]="localizeLink.link.external"
                            [signInRequired]="
                              localizeLink.link.signInLink
                                | ftIsSignInRequired
                                | async
                            "
                          ></eds-article-sidebar-item>
                        </ng-container>
                        <ng-container
                          *ngIf="
                            i <
                            content.relatedContent[0]?.localizableLink.length -
                              1
                          "
                        >
                          <eds-divider
                            *ngIf="localizeLink.isAllowed"
                            edsPadding
                            edsPaddingBottom="sm"
                          ></eds-divider>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </eds-article-side-bar>
            </div>
          </div>
          <!-- /article sidebar -->
        </div>
      </div>
    </section>
    <!-- /article content area -->

    <section edsGrid>
      <div class="container container--wide">
        <div edsRow>
          <div edsCol [columnNumbers]="{ l: 9 }">
            <eds-divider></eds-divider>
          </div>
        </div>
      </div>
    </section>

    <div edsPadding edsPaddingBottom="xxl"></div>
    <ng-container *ngIf="content.displayInsightsCards">
      <section id="chapters" edsGrid edsSpacing="xxl">
        <div class="container container--wide">
          <ft-insights-cards
            [externalPreFilters]="content.insightsCardsFilters"
            [externalInsightResource]="insightsResource"
            [externalSIMLogoResource]="simLogoResourceBundle"
          ></ft-insights-cards>
        </div>
      </section>
    </ng-container>
  </div>
  <ng-template let-content="content" #articleInforTemplete>
    <ng-container *ngIf="showArticleInfo">
      <eds-article-info
        [logoLink]="content.SIM?.logoSrc"
        [href]="content.SIM?.logoHref"
        [altLogoText]="content.SIM?.logoAltText | titlecase"
        [articleLink]="content.alternativeArticle?.link"
        [articleHeading]="translationLabel?.alternativeArticleTitle"
        [articleBody]="content.alternativeArticle?.title"
        [sectionDetails]="content.sections?.length ? content.sections : ''"
        [contributionLabel]="translationLabel?.contributors"
        [avatars]="content.contributors?.length ? content.contributors : ''"
        [contributorsBiography]="
          content.biographyDynamicProfile?.length
            ? content.biographyDynamicProfile
            : ''
        "
        [contactTitle]="translationLabel?.contact"
        [company]="content.company"
        [contactName]="content.contactName"
        [contactTelephone]="content.contactTelephone"
        [documentTitle]="''"
        [infoItem]="''"
      ></eds-article-info>
    </ng-container>
  </ng-template>

  <!-- no document -->
  <div *ngIf="!document && isEditMode" class="no-document">
    <div edsGrid class="no-document__component">
      <div class="no-document__overlay">
        Click to configure <strong>Content Blocks</strong>
      </div>
    </div>
  </div>
  <ng-container *ngIf="segmentOk">
    <div edsGrid>
      <div class="container--wide">
        <div
          edsRow
          edsSpacing
          edsPadding
          edsPaddingTop="lg"
          edsPaddingBottom="lg"
        >
          <div edsCol>
            <eds-notifications
              [title]="'common.page-restricted-alert-title' | translate"
              [body]="'common.page-restricted-alert-body' | translate"
              [hasIcon]="true"
              notificationType="warning"
              [canClose]="false"
            ></eds-notifications>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- no content -->
  <section edsGrid>
    <div class="container container--wide">
      <div edsRow *ngIf="!content" edsPadding edsPaddingTop="lg">
        <p class="large bold">
          {{ translationLabel?.noArticleContent }}
        </p>
      </div>
    </div>
  </section>
</div>
